<template>
  <div class="app">
    <popup-select
      ref="popupSelect"
      :custom="true"
      :title="'选择院区'"
      :forced="forced"
    >
      <div slot="custom">
        <ul class="list list-header">
          <li class="list-item last ellipsis">请选择您要导航去的院区</li>
        </ul>
        <ul class="list">
          <li
            class="list-item arr-row"
            v-for="(area, index) of areaList"
            :key="index"
            @click.stop.prevent="selectArea(area)"
          >
            <div class="hospital-info">
              <div
                class="logo"
                v-bind:style="{
                  backgroundImage: 'url(' + selectedHospital.hospitalLogo + ')',
                }"
              ></div>
              <div class="info">
                <p class="f-large f-normal ellipsis">{{ area.areaName }}</p>
                <p class="f-small f-dark-gray ellipsis">{{ area.areaAddr }}</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </popup-select>
  </div>
</template>
<script>
import wechatService from 'wechat.service'
import wx from 'jweixin-1.4.0'
import utils from 'utils'
import areaMap from "dict/map"


/* eslint-disable */
export default {
  components: {

  },
  data () {
    return {
      forced: true,
      // 选医院界面传来的院区列表
      areaList: this.$store.state.paramModule.param.areaSelect.areaList,
      // 选医院界面传来的
      selectedHospital: this.$store.state.paramModule.param.areaSelect.selectedHospital,
      // 当前所选的院区
      selectedArea: localStorage.selectedArea || {},
      // 微信API配置相关
      wechatConfig: {},
      //所有院区的经纬度
      areaMap: areaMap,
      // 目的地位置坐标
      targetPoint: {
        latitude: '',
        longitude: ''
      }
    }
  },
  methods: {
    selectArea (area) {
      this.selectedArea = area;
      this.forced = false;
      localStorage.selectedArea = JSON.stringify(area);
      // 来院导航需要先去定位
      if (this.$store.state.paramModule.param.menu.url === 'outMap') {
        this.$store.commit('updateParam', {
          namespace: 'getLocation',
          url: this.$store.state.paramModule.param.menu.url,
        });
        // const ua = navigator.userAgent.toLowerCase();
        // if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //   this.getTargetPoint()
        //   return
        // } else {
        //   this.$router.push('getLocation')
        //   return
        // }
        this.getTargetPoint()
        return
      }
      this.$router.push(this.$store.state.paramModule.param.menu.url)
    },
    getTargetPoint () {
      // 拿到院区地址
      const areaId = JSON.parse(localStorage.selectedArea).areaId;
      const point = this.areaMap[areaId];
      if (undefined === point) {
        utils.alert('未获取到医院经纬度');
        return;
      }
      this.targetPoint.latitude = point.lat;
      this.targetPoint.longitude = point.lng;
      this.getWxConfigParams();
    },
    /**
     * 获取初始化微信API所需的参数(微信appId，签名等)
     */
    getWxConfigParams () {
      // 调用后台接口获取微信API所需要的appId等参数
      const entryUrl = window.entryUrl;//encodeURIComponent(window.entryUrl)
      wechatService.getWechatConfig({
        url: entryUrl,
        orgId: http.headers.common['organizationId'],
      }).then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          utils.alert('获取初始化微信API所需的参数失败： ' + res.resultMsg)
          return
        }
        this.wechatConfig = res.data
        this.initWxAPI()
      })
    },
    /**
     * 初始化微信API
     */
    initWxAPI () {
      const that = this;
      if (typeof (wx) === 'undefined') {
        utils.alert('由于微信版本兼容性问题，无法使用微信API');
        return
      }
      wx.config({
        debug: false,
        appId: this.wechatConfig.appId, // 必填，公众号的唯一标识
        timestamp: this.wechatConfig.timestamp, // 必填，生成签名的时间戳
        nonceStr: this.wechatConfig.nonceStr, // 必填，生成签名的随机串
        signature: this.wechatConfig.signature, // 必填，微信签名
        jsApiList: ['getLocation', 'openLocation'],// 必填，需要使用的JS接口列表
      })
      wx.ready(() => {
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
        wx.openLocation({
          latitude: parseFloat(that.targetPoint.latitude), // 纬度，浮点数，范围为90 ~ -90
          longitude: parseFloat(that.targetPoint.longitude), // 经度，浮点数，范围为180 ~ -180。
          name: JSON.parse(localStorage.selectedArea).areaName, // 位置名
          address: JSON.parse(localStorage.selectedArea).areaAddr, // 地址详情说明
          scale: 13, // 地图缩放级别,整形值,范围从1~28。默认为最大
          infoUrl: '', // 在查看位置界面底部显示的超链接,可点击跳转
        });
      });
      wx.error((err) => {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        utils.alert('微信API注册失败' + JSON.stringify(err))
      });
    },
  }
}
</script>

<style lang="scss">
@import "../../../static/sass/_variable.scss";
.list {
  .list-item {
    &.def {
      padding-top: 0.25rem;
      padding-bottom: 0.25rem;
    }
    &.last {
      padding-right: 0.5rem !important;
      color: $main-style-color;
    }
  }
}
.list-header {
  background-color: #e1edfb;
}
.hospital-info {
  @include display-flex();
  @include align-items(center);
  .logo {
    width: 1.5rem;
    height: 1.5rem;
    background-image: url(../../../static/img/hos-def-logo.png);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  .info {
    @include flex(1);
    @include ellipsis();
    width: 1px;
    padding-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// AreaSelect.vue?8a01a744